import one from '../assets/svg/projects/one.svg'
import two from '../assets/svg/projects/two.svg'
import three from '../assets/svg/projects/three.svg'
import four from '../assets/svg/projects/four.svg'
import five from '../assets/svg/projects/five.svg'
import six from '../assets/svg/projects/six.svg'
import seven from '../assets/svg/projects/seven.svg'
import eight from '../assets/svg/projects/eight.svg'


export const projectsData = [
    {
        id: 1,
        projectName: 'Rainbow',
        projectDesc: 'Its a social media platform that is open for all but gives slight prominence to the inclusiveness of LGBTQ+ members into the social mainstream.',
        tags: ['React', 'CSS', 'Material Ui','Firebase','MongoDB','Bootstrap'],
        code: 'https://github.com/Emerald-Rainbow',
        demo: 'https://rainbow-emerald.netlify.app/',
        image: one
    },
    {
        id: 4,
        projectName: 'Appliquer',
        projectDesc: 'This is a job application portal.',
        tags: ['React js', 'Django','Material UI','JWT', 'React-Bootstrap'],
        code: 'https://github.com/dev-triangle/appliquer-frontend',
        demo: '',
        image: four
    },
    {
        id: 2,
        projectName: 'CryptoGram',
        projectDesc: 'A completely decentralized social media website that enables users to interact with their friends and relatives without compromising their privacy and personal info. ',
        tags: ['Blockchain', 'React','web3.js','solidity'],
        code: 'https://github.com/AchyuthMohan/cryptogram-nmit-block-chain-',
        demo: 'https://cryptogram-nmit-block-chain.pages.dev/',
        image: two
    },
    {
        id: 3,
        projectName: 'The Cocktail',
        projectDesc: 'Its a social media app through which a cocktail shopowner can display the cocktails sold on his shop. REST framework is implemented here.',
        tags: ['React', 'CSS', 'Material Ui','MongoDB','nodejs','Express'],
        code: 'https://github.com/XdithyX/TheCocktail',
        demo: 'https://the-cocktail.vercel.app/',
        image: three
    },
   
   /* {
        id: 5,
        projectName: 'E-Commerce App',
        projectDesc: 'A Simple E-commerce application',
        tags: ['React Native', 'Firebase'],
        code: 'https://github.com/hhhrrrttt222111/developer-portfolio',
        demo: 'https://github.com/hhhrrrttt222111/developer-portfolio',
        image: five
    },
    {
        id: 6,
        projectName: 'Uber Lite',
        projectDesc: 'Uber clone',
        tags: ['Flutter'],
        code: 'https://github.com/hhhrrrttt222111/developer-portfolio',
        demo: 'https://github.com/hhhrrrttt222111/developer-portfolio',
        image: six
    },
    {
        id: 7,
        projectName: 'Stock Market App',
        projectDesc: 'A simple stock market API app',
        tags: ['React', 'Redux', 'Bootstrap'],
        code: 'https://github.com/hhhrrrttt222111/developer-portfolio',
        demo: 'https://github.com/hhhrrrttt222111/developer-portfolio',
        image: seven
    },
    {
        id: 8,
        projectName: 'Car Pooling System',
        projectDesc: 'The carpooling system merges multiple people in a car which leads to meet new people, reduces pollution',
        tags: ['Flutter', 'React'],
        code: 'https://github.com/hhhrrrttt222111/developer-portfolio',
        demo: 'https://github.com/hhhrrrttt222111/developer-portfolio',
        image: eight
    }, */
]


// Do not remove any fields.
// Leave it blank instead as shown below

/* 
{
    id: 1,
    projectName: 'Car Pooling System',
    projectDesc: '',
    tags: ['Flutter', 'React'],
    code: '',
    demo: '',
    image: ''
}, 
*/